"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9 11H6a1 1 0 01-1-1L5.91.9a1 1 0 01.995-.9h6.256a.839.839 0 01.779 1.15L11.2 8h2.978a.822.822 0 01.748 1.162l-4.764 10.481A.608.608 0 019 19.392V11z"];
//# sourceMappingURL=lightning.js.map